import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'sparkles';

const originalDimensions = {
    width: 24,
    height: 24,
};

// https://github.com/tailwindlabs/heroicons/blob/master/src/outline/sparkles.svg

export const IconSparkles = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke={fill}
        >
            <title id={iconId}>Sparkles Icon</title>
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
            />
        </svg>
    );
};
